module.exports = __webpack_public_path__ + "static/media/Beach.5e885402.png";